import { MinorSliderType } from 'common/types'

export const MinorSliderData: MinorSliderType[] = [
   {
      _id: '13',
      img: require('../assets/images/ProductCard/Decorations/Quadro-1/quadro-1-img-1.png'),
      alt: 'Produto 1',
      name: 'Devlan Wall Art (Set of 3)',
      price: '38.99',
      bgColor: '#fad3e0',
      cat: 'living-room'
   },
   {
      _id: '5',
      img: require('../assets/images/ProductCard/Decorations/Quadro-2/quadro-2-img-1.png'),
      alt: 'Produto 2',
      name: 'Keep Calm Wall Art',
      price: '38.99',
      bgColor: 'rgb(151, 105, 105)',
      cat: 'kitchen'
   },
   {
      _id: '10',
      img: require('../assets/images/ProductCard/Decorations/Luminaria-1/luminaria-1-img-1.png'),
      alt: 'Produto 3',
      name: 'Jodene Pendant Light',
      price: '500.99',
      bgColor: '#ccc',
      cat: 'bathroom'
   },
   {
      _id: '11',
      img: require('../assets/images/ProductCard/Decorations/Vaso-1/vaso-1-img-1.png'),
      alt: 'Produto 4',
      name: 'Aurora Brown Manufactured Wood Floor Vase',
      price: '1038.99',
      bgColor: 'rgb(238, 225, 183)',
      cat: 'bedroom'
   },
]